/**
 * Quando vale a pena reconferir a permissão de quem já está com o app aberto.
 *
 * O problema que isto resolve (relatado em 17/08/2026): conceder permissão a
 * alguém não fazia efeito até ela SAIR E ENTRAR no CRM. Os dois mapas do front
 * — o de rotas do Hub (`userAccessMap`) e a matriz granular do CRM — são
 * buscados UMA vez por sessão de página e nunca mais. Enquanto a aba fica
 * aberta, a pessoa continua com a permissão de antes: ou sem ver o que acabou
 * de ganhar, ou vendo o que acabou de perder.
 *
 * A régua é pura de propósito, para ser testada sem navegador. Duas decisões:
 *
 * - **Reconferir ao VOLTAR para a aba** é o gesto certo: é exatamente o momento
 *   em que a pessoa foi avisada ("te dei acesso, tenta agora") e volta para
 *   tentar. Fora dele, um relógio de fundo pediria a mesma resposta o dia
 *   inteiro para quase sempre receber o mesmo mapa.
 * - **Com carência (`JANELA_MS`)**, porque `visibilitychange` dispara a cada
 *   alt-tab: sem ela, quem trabalha alternando entre o CRM e o Outlook geraria
 *   uma consulta por troca de janela.
 */

/** Quanto tempo um mapa recém-buscado é considerado fresco. */
export const JANELA_MS = 60_000;

export interface EstadoRevalidacao {
  /** `Date.now()` da última busca concluída. `0` = nunca buscou. */
  buscadoEm: number;
  /** Uma busca em andamento — não faz sentido pedir outra. */
  buscando: boolean;
}

/**
 * Vale reconferir agora?
 *
 * `agora` entra por parâmetro (nunca `Date.now()` aqui dentro) para o teste
 * poder afirmar a borda da janela sem esperar um minuto de verdade.
 */
export function deveRevalidar(estado: EstadoRevalidacao, agora: number): boolean {
  if (estado.buscando) return false;
  // Nunca buscou: quem decide é o carregamento inicial, não esta régua — pedir
  // aqui competiria com ele e faria dois GETs na abertura do app.
  if (!estado.buscadoEm) return false;
  return agora - estado.buscadoEm >= JANELA_MS;
}
